import * as React from 'react';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import {LeadChangePipeline} from './lead-change-pipeline';

type Props = {
    lead: LeadFragment;
};

export function LeadPipelineHeader(props: Props) {
    return (
        <h2 className='ui-section-label'>
            {props.lead.stageset ? (
                <LeadChangePipeline leadId={props.lead.id} stageset={props.lead.stageset} />
            ) : (
                <span>Stages</span>
            )}
        </h2>
    );
}
